import BrowserCtrl from './browser.controller';
import mailEditor from './directives/mail-editor';
import pfdDownload from './directives/pdfDownload';
import availabilityPanel from './directives/inBrowserPanel';
import horizontalResizer from './directives/resizer';
import Rest from '../main/services/Rest';
import Events from '../main/services/Events';
import TokenHandler from '../login/services/tokenHandler';
import Browser from './browser.repository';

export default angular.module('app.browser', [])
    .controller('BrowserCtrl', BrowserCtrl)
    .directive('mailEditor', () => new mailEditor)
    .directive('pdfDownload', () => new pfdDownload)
    .directive('availabilityPanel', () => new availabilityPanel)
    .directive('horizontalResizer', () => new horizontalResizer)
    .service('Browser', Browser)
    .service('Events', Events)
    .service('Rest', Rest)
    .service('TokenHandler', TokenHandler)
    .name;
